import { FestivalCampaignPage } from "@/pages/Navratri";

const DIWALI_CONFIG = {
  campaignKey: "diwali-2026",
  badge: "Diwali",
  heroImage: "/assets/diwali-hero.jpg",
  endpoint: "/campaigns/diwali-2026/events",
  loadingLabel: "Loading Diwali celebrations...",
  emptyTitle: "No Diwali listings found",
  upcomingTitle: "Upcoming Diwali celebrations",
  fallbackCampaign: {
    key: "diwali-2026",
    label: "Diwali 2026",
    title: "Diwali celebrations, melas and community gatherings",
    subtitle: "Discover Diwali events tagged for the festive season across the UK.",
  },
  useSeasonalOption: false,
};

export default function Diwali() {
  return <FestivalCampaignPage config={DIWALI_CONFIG} />;
}
